import { Box } from '@mui/material';
import { GridFooter, GridFooterContainer } from '@mui/x-data-grid-pro';
import PageSizeDropdown from './PageSizeDropdown';

interface GridListFooterProps {
  pageSize: number;
  pageSizeOptions?: number[];
  onPageSizeChange: (newPageSize: number) => void;
}

const GridListFooter: React.FC<GridListFooterProps> = (props: GridListFooterProps) => {
  const { pageSize, pageSizeOptions, onPageSizeChange } = props;
  
  return (
    <GridFooterContainer sx={{ height: '42px', minHeight: 'unset' }}>
      <Box sx={{ px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
        <PageSizeDropdown
          selectedPageSize={pageSize}
          onPageSizeSelectionChange={onPageSizeChange}
          pageSizes={pageSizeOptions}
        />
        <GridFooter sx={{ border: 'unset', height: '100%', minHeight: 'unset' }} />
      </Box>
    </GridFooterContainer>
  );
};

export default GridListFooter;
